import $ from 'jquery';
import { getState, modifyState } from '~src/state';
import { EdgeResizer } from '~src/utils';
import { fetchClothes } from '~graphql/controllers';
import {
  clothesTranslations,
  colorTranslations,
} from '~core/changeClothes/localizazion';

const createClothingItemHtml = (item) => {
  if (!item.image?.url) {
    return '';
  }

  const previewImg = new EdgeResizer(item.image.url).scaleToWidth(160);

  return `
    <div class="col-6 mb-3 px-2">
      <div class="sidebar-item-grid-box image-square-container position-relative">
        <div id="editor-sidebar-change-clothes-${item.objectId}"
             data-cloth-url="${item.image.url}" 
             data-prompt="${item.prompt || ''}" 
             data-color="${item.color || 'Unknown'}"
             data-category="${item.item || 'Unknown'}"
             class="sidebar-item-grid-box-click-listener position-absolute w-100 h-100"
             style="cursor: pointer; z-index: 2;"></div>
        <img
          src="${previewImg}"
          class="image-square"
          alt="Garment"
        />
      </div>
    </div>
  `;
};

const applyFilters = (clothes, category, color) => {
  return clothes.filter((item) => {
    const typeMatch = category === 'all' || !category || item.item === category;
    const colorMatch = color === 'all' || !color || item.color === color;
    return typeMatch && colorMatch;
  });
};

export default function displayClothes(gender, clothes) {
  let container;
  if (gender === 'm') {
    container = $('#editor-sidebar-change-clothes-uomo');
  } else {
    container = $('#editor-sidebar-change-clothes-donna');
  }

  if (!container.length) {
    console.error('Change clothes container not found for gender:', gender);
    return;
  }

  if (!clothes || clothes.length === 0) {
    container.html(
      '<div class="col-12"><div class="text-center text-muted py-5">Non ci sono vestiti disponibili</div></div>'
    );
    return;
  }

  const category = getState('changeClothesFiltersCategory', 'all');
  const color = getState('changeClothesFiltersColor', 'all');

  const filteredClothes = applyFilters(clothes, category, color);

  if (filteredClothes.length === 0) {
    container.html(
      '<div class="col-12"><div class="text-center text-muted py-5">Nessun vestito corrisponde ai filtri selezionati</div></div>'
    );
    return;
  }

  const clothesHtml = filteredClothes.map(createClothingItemHtml).join('');
  container.html(clothesHtml);

  if (window.lazyLoadInstance) {
    window.lazyLoadInstance.update();
  }
}

// Function to handle filter changes
export function handleFilterChange() {
  const gender = getState('changeClothesGender');
  const clothes = getState('changeClothesClothes', []);
  displayClothes(gender, clothes);
}

// Function to handle gender changes
export async function handleGenderChange() {
  const gender = getState('changeClothesGender');

  try {
    const clothes = await fetchClothes({
      forceFetch: false,
      gender,
      limit: 10000,
    });

    if (clothes && clothes.length > 0) {
      modifyState('changeClothesClothes', clothes);

      // Update category filter
      const categories = [
        ...new Set(clothes.map((cloth) => cloth.item || '')),
      ].filter(Boolean);

      // Create array of objects with original and translated values
      const translatedCategories = categories.map((category) => ({
        value: category,
        label: clothesTranslations[category.toLowerCase()] || category,
      }));

      // Sort by Italian translation
      translatedCategories.sort((a, b) => a.label.localeCompare(b.label, 'it'));

      const categoryFilter = $('#change-clothes-filter-category');
      // Clear all existing options
      categoryFilter.empty();
      // Re-add the "all" option
      categoryFilter.append('<option value="all">Tutti</option>');
      // Add sorted translated options
      translatedCategories.forEach(({ value, label }) => {
        categoryFilter.append(`<option value="${value}">${label}</option>`);
      });

      // Update color squares
      const colors = [
        ...new Set(clothes.map((cloth) => cloth.color || '')),
      ].sort();
      const colorContainer = $('#change-clothes-color-squares');
      colorContainer.empty();

      // Add "All" option
      colorContainer.append(`
        <div class="change-clothes-color-square active" data-color="all" title="Tutti i colori">
          <div class="change-clothes-color-square-inner change-clothes-all-colors">
            <span>Tutti</span>
          </div>
        </div>
      `);

      colors.forEach((color) => {
        if (color) {
          const colorData = colorTranslations[color.toLowerCase()];
          if (colorData) {
            colorContainer.append(`
              <div class="change-clothes-color-square" data-color="${color}" title="${
              colorData.it
            }">
                <div class="change-clothes-color-square-inner" style="background-color: ${
                  colorData.hexColor
                }">
                  ${
                    colorData.hexColor === '#FFFFFF'
                      ? '<div class="change-clothes-white-border"></div>'
                      : ''
                  }
                </div>
              </div>
            `);
          }
        }
      });

      // Reset filter states
      modifyState('changeClothesFiltersCategory', 'all');
      modifyState('changeClothesFiltersColor', 'all');
      $('#change-clothes-filter-category').val('all');

      displayClothes(gender, clothes);
    }
  } catch (error) {
    console.error('Error loading clothes for gender change:', error);
  }
}
